import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel, PayWithMyBankModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { first } from 'rxjs/operators';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { BalanceModel } from 'src/app/models/balance-model';
import { ConfigService } from 'src/app/services/config/config.service';
import { DepositService } from 'src/app/services/cashier/deposit.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { IonContent, LoadingController, Platform } from '@ionic/angular';
//import { registerPlugin} from '@capacitor/core';

declare var window: any
declare var PayWithMyBank: any;

// interface CapacitorPluginPaywithmybank {
//   selectBankWidget( options: { value: string}): Promise<{ value: string}>;
// }
//const PayWithMyBankCapacitor = registerPlugin<CapacitorPluginPaywithmybank>('CapacitorPluginPaywithmybank');

@Component({
  selector: 'app-deposit-paywithmybank',
  templateUrl: './deposit-paywithmybank.component.html',
  styleUrls: ['./deposit-paywithmybank.component.scss'],
})

export class DepositPaywithmybankComponent extends CashierBase implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public navigateBackPage: any;

  public accounts: Array<any> = [];
  public accountBalances: BalanceModel;
  public bonusCode: string;
  public buttonDisabled: boolean = false;
  public defaultAmounts: any = [];
  public error = null;
  public labels: DepositMainLabels;
  public loading: any;
  public loadingSecond: any;
  public minAmount: any;
  public paymentType: any = [];
  public selectedAccount: any;
  public showAddAccounts = true;
  public isCapacitor: boolean = false;
  public isMobile: boolean = false;

  public depositForm: FormGroup;
  public amount: AbstractControl;

  private balanceSubscription;
  private customerObj: any = {};
  private depositTimeout: any;
  private exceededDepositLimit: boolean = false;
  private getActivePaymentTypesSubscription;
  private timeoutDepositTimer: number = 25;

  private payWithMyBankOptions: any = {
    closeButton: false,
    dragAndDrop: false,
    widgetContainerId: "pwb-container" //Page element container for the widget
  };

  private dataToEstablish: any = {
    accessId: this.config.getConfig().FEATURE_PWMB_ACCESS_ID,
    customer: this.customerObj,
    merchantId: this.config.getConfig().FEATURE_PWMB_MERCHANT_ID,
    // merchantReference must be unique each time, generated in the Signature query below
    //paymentType: 'Verification',
    paymentType: 'Deferred',
    //authToken: 'new',
    returnUrl: '#return',
    cancelUrl: '#cancel'
  };


  constructor(
    public accountBalanceService: AccountBalanceService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public config: ConfigService,
    public depositService: DepositService,
    public events: EventsService,
    public loadingController: LoadingController,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
    public UserSessionService: UserSessionService,
    public utils: UtilsService,
    public platform: Platform
  ) {
    super();
    this.cashierService.setupPayWithMyBank();
    this.successMessageService.clearMessage();
    this.isMobile = this.platform.is('mobile');
    this.isCapacitor = this.platform.is('capacitor');   // capacitor requires native non-web implementation
    this.error = null;
    this.labels = new PayWithMyBankModel();
    this.timeoutDepositTimer = this.config.getConfig().DEPOSIT_LOADING_TIMEOUT ? Number(this.config.getConfig().DEPOSIT_LOADING_TIMEOUT) : 25 
  }

  ngOnInit(): void {
    this.depositForm = new FormGroup(
      {
        accountList: new FormControl('', [Validators.required]),
        amount: new FormControl('', {
          validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required],
          updateOn: 'change'
        }),
      }

    )

    this.amount = this.depositForm.get('amount');
    this.onGetAccounts();
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.getActivePaymentTypesSubscription = this.cashierService.getActivePaymentTypes('PWB').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        this.minAmount = this.paymentType[0].min;
        this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    }
    );

    this.events.subscribe('event:deposit', (data) => {
      if (data?.paymentMethod === 'PWB') {
        clearTimeout(this.depositTimeout);
        this.checkDepositApproved();
      }
    });

    this.events.subscribe('event:deposit:failed', (e) => {
      clearTimeout(this.depositTimeout);
      this.buttonDisabled = false;
      this.checkDepositFailed(e);
    });
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('paywithmybank').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ngOnDestroy() {
    if (typeof PayWithMyBank !== 'undefined') {
      PayWithMyBank.removePanelListener();
    }
    this.balanceSubscription.unsubscribe();
    this.getActivePaymentTypesSubscription.unsubscribe();
    this.events.unsubscribe('event:deposit:approved');
    this.events.unsubscribe('event:deposit:failed');
    window.removeEventListener('message', (event: MessageEvent) => { });
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: 5000
    });

    this.loading.present();
  }

  async showLoadingSecond() {

    this.loadingSecond = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: this.timeoutDepositTimer * 1000
    });

    this.loadingSecond.present();
  }

  public checkDepositApproved() {
    this.loading?.dismiss();
    this.loadingSecond?.dismiss();
    if (this.exceededDepositLimit) return this.navigator.navigateTo('DepositThresholdComponent', {}, { status: true, amount: this.depositForm.get('amount').value, customerId: this.cashierService.customer.customerId });
    return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { amount: this.depositForm.get('amount').value, status: true, message: 'Your balance will be updated shortly.' });
  }

  public checkDepositFailed(e: any) {
    this.loading?.dismiss();
    this.loadingSecond?.dismiss();
    if (e.parametersMap.error_code === 'SW057' || e.parametersMap.error_code === 'SW051' || e.parametersMap.error_message === 'splitToken is not valid' || e.parametersMap.error_message === 'splitToken has expired') {
      let transactionId = e.parametersMap.external_id;
      this.onGetAccounts();
      this.showAddAccounts = true;
      return this.expiredTokenWorkFlow(transactionId);
    }

    let message = e.text;
    if (e.customField6 == 'TEST_ACCOUNT_MAX_FUNDS_REACHED') message = 'Cannot deposit more than 999 on test account.';
    if (e.customField6 == 'OVER_DEPOSIT_LIMIT') message = 'You have exceeded your maximum deposit limit'; // error message will show in modal
    return this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { amount: this.depositForm.get('amount').value, status: false, message: message });
  }


  public initAddAccount() {
    setTimeout(() => {
      this.getPWBSignature(this.dataToEstablish);
    }, 1500);
  }

  public expiredTokenWorkFlow(transactionId: string) {
    if (!!transactionId) {
      this.dataToEstablish.paymentType = 'Verification';
      this.dataToEstablish.authToken = 'new';
      this.dataToEstablish.transactionId = transactionId;
    }

    setTimeout(() => {
      this.getPWBSignature(this.dataToEstablish, true);
    }, 500);
  }


  public getPWBSignature(data, expiredSplitToken = false) {

    // must be unique each call
    data.merchantReference = Date.now() + `|${this.UserSessionService.sessionToken}`;

    if (this.config.getConfig().FEATURE_PWMB_COUNTRY) {
      data.country = this.config.getConfig().FEATURE_PWMB_COUNTRY;
    }

    if (this.config.getConfig().FEATURE_PWMB_CURRENCY) {
      data.currency = this.config.getConfig().FEATURE_PWMB_CURRENCY;
    }

    data.customer = this.customerObj;

    this.cashierService.getPwbRequestSignature(this.generateQuery(data)).subscribe((response: any) => {
      if (response && !!response.result) {
        this.loading?.dismiss();
        data['requestSignature'] = response.payload;
        if ("undefined" !== typeof this.config.getConfig().FEATURE_PWMB_TRUSTLY_ENV) {
          data['env'] = this.config.getConfig().FEATURE_PWMB_TRUSTLY_ENV;
        }
        if (!this.platform.is('capacitor')) {
          if (expiredSplitToken === true) {
            PayWithMyBank.establish(data, this.payWithMyBankOptions);
          } else {
            PayWithMyBank.selectBankWidget(data, this.payWithMyBankOptions);
          }
        } else {
          if (expiredSplitToken === true) {
            this.invokeMobileEstablish(data)
          }
        }
      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });

    let dis = this;

    if (typeof PayWithMyBank !== 'undefined') {
      PayWithMyBank.addPanelListener(function (command, event) {
        if (command === 'event' && event.type === 'new_location') {
          let cancel = event.data.indexOf('#cancel') === 0;
          let accountAdded = event.data.indexOf('#return') === 0;

          if (cancel || accountAdded) {
            // Prevent redirection
            event.preventDefault();
            if (accountAdded) dis.onGetAccounts(true);
            PayWithMyBank.removePanelListener();
          }

        }
      });
    }
  }

  public invokeMobileAddAccount(data) {
    // must be unique each call
    data.merchantReference = Date.now() + `|${this.UserSessionService.sessionToken}`;

    if (this.config.getConfig().FEATURE_PWMB_COUNTRY) {
      data.country = this.config.getConfig().FEATURE_PWMB_COUNTRY;
    }

    if (this.config.getConfig().FEATURE_PWMB_CURRENCY) {
      data.currency = this.config.getConfig().FEATURE_PWMB_CURRENCY;
    }

    data.customer = this.customerObj;
    
    this.cashierService.getPwbRequestSignature(this.generateQuery(data)).subscribe((response: any) => {
      if (response && !!response.result) {
        this.loading?.dismiss();
        data['requestSignature'] = response.payload;
        if ("undefined" !== typeof this.config.getConfig().FEATURE_PWMB_TRUSTLY_ENV) {
          data['env'] = this.config.getConfig().FEATURE_PWMB_TRUSTLY_ENV;
        }
        if (this.platform.is('capacitor')) {
          window.cordova.plugins.PayWithMyBank.selectBankWidget(data, () => {
            setTimeout(() => {
              this.onGetAccounts(true);
            }, 2 * 1000);
          }, (err) => {
            console.log('PWMB: selectBankWidget error: ', err);
          });
        } else {
          console.log('in mobile context the web calls should not happen.');
          //          PayWithMyBank.selectBankWidget(data, this.payWithMyBankOptions);
        }
      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });
  }

  public invokeMobileEstablish(data) {
    if (this.platform.is('capacitor')) {
      window.cordova.plugins.PayWithMyBank.establish(data, () => {
        console.log('PWMB: establish success: ', data);
        setTimeout(() => {
          console.log('PWMB: establish: onGetAccounts()... ');
          this.onGetAccounts(true);
        }, 2 * 1000);
      }, (err) => {
        console.log('PWMB: establish error: ', err);
      });
    } else {
      console.log('in mobile context the web calls should not happen.');
      //          PayWithMyBank.selectBankWidget(data, this.payWithMyBankOptions);
    }
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  public onGetAccounts(newAccountAdded: boolean = false) {
    this.cashierService.callListAccounts().pipe(first()).subscribe((response: any) => {
      if (response && !!response.result) {
        this.accounts = response.payload.filter(account => account.paymentTypeCode === "PWB").map((account, key) => {
          account.id = key;
          return account;
        });

        if (this.accounts.length) {
          this.showAddAccounts = false;
          this.selectedAccount = this.accounts[0].id;
          if (!newAccountAdded) this.content.scrollToTop(100);
        }
      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });

    this.balanceSubscription = this.accountBalanceService.getBalance().subscribe((balance: BalanceModel) => {
      if (balance) {
        this.accountBalances = balance;
        this.setCustomerObject();
      }

      const rawTaxID = this.config?.getConfig()?.FEATURE_PWMB_TAXID; //this value should be true or false in BO
      const taxID: any = !!rawTaxID ? JSON.parse(rawTaxID) : false;
      if (taxID) return this.initAddAccount();
      return this.checkForSsn();
    });
  }

  public checkForSsn() {
    this.cashierService.getPwbEncryptedSsn().pipe(first()).subscribe((response: any) => {
      if (response && !!response.result) {
        if( response.payload && response.payload.ssnEncrypted) {
          this.customerObj.taxId = response.payload.ssnEncrypted
        }
        return this.initAddAccount();
      }
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });
  }

  public setCustomerObject() {
    let country = this.cashierService.customer.address.country;
    country = this.changeCountryValue(country);

    this.customerObj = {
      "customerId": this.cashierService.customer.customerId,
      "externalId": this.cashierService.customer.customerId,
      "merchantId": this.config.getConfig().FEATURE_PWMB_MERCHANT_ID,
      "name": this.cashierService.customer.firstName + " " + this.cashierService.customer.lastName,
      "address": {
        "address1": this.cashierService.customer.address.street,
        "address2": this.cashierService.customer.address.street2,
        "city": this.cashierService.customer.address.city,
        "state": this.cashierService.customer.address.state,
        "zip": this.cashierService.customer.address.postalCode,
        "country": country
      },
      "phone": "+1" + this.cashierService.customer.address.phoneNumber,
      "email": this.cashierService.customer.email,
      "dateOfBirth": this.cashierService.customer.birthDate
    }

    if (this.accountBalances.hasEnrollDate()) {
      let enrollDate = this.accountBalances.getEnrollDate();
      this.customerObj['enrollDate'] = enrollDate.getTime();
    }

  }

  public changeCountryValue(country: string): string {
    if (country === "USA") return 'US';
    if (country === "CAN") return 'CA';
  }

  private generateQuery = (establishData) => {
    let query = '';

    query += `accessId=${encodeURIComponent(establishData.accessId)}`;
    query += `&merchantId=${encodeURIComponent(establishData.merchantId)}`;

    if (establishData.description) {
      query += `&description=${encodeURIComponent(establishData.description)}`;
    }

    if (establishData.currency) {
      query += `&currency=${encodeURIComponent(establishData.currency)}`;
    }

    if (establishData.amount) {
      query += `&amount=${encodeURIComponent(establishData.amount)}`;
    }

    if (establishData.displayAmount) {
      query += `&displayAmount=${encodeURIComponent(establishData.displayAmount)}`;
    }

    if (establishData.minimumBalance) {
      query += `&minimumBalance=${encodeURIComponent(establishData.minimumBalance)}`;
    }

    query += `&merchantReference=${encodeURIComponent(establishData.merchantReference)}`;

    query += `&paymentType=${encodeURIComponent(establishData.paymentType)}`;

    if (establishData.timeZone) {
      query += `&timeZone=${encodeURIComponent(establishData.timeZone)}`;
    }

    if (establishData.paymentType === 'Recurring' && establishData.recurrence) {
      if (establishData.recurrence.startDate) query += `&recurrence.startDate=${encodeURIComponent(establishData.recurrence.startDate)}`;
      if (establishData.recurrence.endDate) query += `&recurrence.endDate=${encodeURIComponent(establishData.recurrence.endDate)}`;
      if (establishData.recurrence.frequency) query += `&recurrence.frequency=${encodeURIComponent(establishData.recurrence.frequency)}`;
      if (establishData.recurrence.frequencyUnit) query += `&recurrence.frequencyUnit=${encodeURIComponent(establishData.recurrence.frequencyUnit)}`;
      if (establishData.recurrence.frequencyUnitType) query += `&recurrence.frequencyUnitType=${encodeURIComponent(establishData.recurrence.frequencyUnitType)}`;
      if (establishData.recurrence.recurringAmount) query += `&recurrence.recurringAmount=${encodeURIComponent(establishData.recurrence.recurringAmount)}`;
      if (establishData.recurrence.automaticCapture) query += `&recurrence.automaticCapture=${encodeURIComponent(establishData.recurrence.automaticCapture)}`;
    }

    if (establishData.verification) {
      if (establishData.verification.status) query += `&verification.status=${encodeURIComponent(establishData.verification.status)}`;
      if (establishData.verification.verifyCustomer) query += `&verification.verifyCustomer=${encodeURIComponent(establishData.verification.verifyCustomer)}`;
    }

    if (establishData.customer) {
      if (establishData.customer.customerId) query += `&customer.customerId=${encodeURIComponent(establishData.customer.customerId)}`;
      if (establishData.customer.externalId) query += `&customer.externalId=${encodeURIComponent(establishData.customer.externalId)}`;
      if (establishData.customer.name) query += `&customer.name=${encodeURIComponent(establishData.customer.name)}`;
      if (establishData.customer.vip !== undefined) query += `&customer.vip=${encodeURIComponent(establishData.customer.vip)}`;
      if (establishData.customer.taxId) query += `&customer.taxId=${encodeURIComponent(establishData.customer.taxId)}`;
      if (establishData.customer.driverLicense) {
        if (establishData.customer.driverLicense.number) query += `&customer.driverLicense.number=${encodeURIComponent(establishData.customer.driverLicense.number)}`;
        if (establishData.customer.driverLicense.state) query += `&customer.driverLicense.state=${encodeURIComponent(establishData.customer.driverLicense.state)}`;
      }
      if (establishData.customer.address) {
        if (establishData.customer.address.address1) query += `&customer.address.address1=${encodeURIComponent(establishData.customer.address.address1)}`;
        if (establishData.customer.address.address2) query += `&customer.address.address2=${encodeURIComponent(establishData.customer.address.address2)}`;
        if (establishData.customer.address.city) query += `&customer.address.city=${encodeURIComponent(establishData.customer.address.city)}`;
        if (establishData.customer.address.state) query += `&customer.address.state=${encodeURIComponent(establishData.customer.address.state)}`;
        if (establishData.customer.address.zip) query += `&customer.address.zip=${encodeURIComponent(establishData.customer.address.zip)}`;
        if (establishData.customer.address.country) query += `&customer.address.country=${encodeURIComponent(establishData.customer.address.country)}`;
      }
      if (establishData.customer.phone) query += `&customer.phone=${encodeURIComponent(establishData.customer.phone)}`;
      if (establishData.customer.email) query += `&customer.email=${encodeURIComponent(establishData.customer.email)}`;
      if (establishData.customer.balance) query += `&customer.balance=${encodeURIComponent(establishData.customer.balance)}`;
      if (establishData.customer.currency) query += `&customer.currency=${encodeURIComponent(establishData.customer.currency)}`;
      if (establishData.customer.enrollDate) query += `&customer.enrollDate=${encodeURIComponent(establishData.customer.enrollDate)}`;
      if (establishData.customer.dateOfBirth) query += `&customer.dateOfBirth=${encodeURIComponent(establishData.customer.dateOfBirth)}`;
    }

    if (establishData.account) {
      if (establishData.account.nameOnAccount) query += `&account.nameOnAccount=${encodeURIComponent(establishData.account.nameOnAccount)}`;
      if (establishData.account.name) query += `&account.name=${encodeURIComponent(establishData.account.name)}`;
      if (establishData.account.type) query += `&account.type=${encodeURIComponent(establishData.account.type)}`;
      if (establishData.account.profile) query += `&account.profile=${encodeURIComponent(establishData.account.profile)}`;
      if (establishData.account.accountNumber) query += `&account.accountNumber=${encodeURIComponent(establishData.account.accountNumber)}`;
      if (establishData.account.routingNumber) query += `&account.routingNumber=${encodeURIComponent(establishData.account.routingNumber)}`;
    }

    if (establishData.transactionId) query += `&transactionId=${encodeURIComponent(establishData.transactionId)}`;
    return query;
  }

  public onAddAccount(): void {
    if (this.isCapacitor && this.showAddAccounts) {
      this.invokeMobileAddAccount(this.dataToEstablish);
    }
    this.showAddAccounts = !this.showAddAccounts;
  }

  public onAmountSelected(data) {
    return this.depositForm.get('amount').setValue(data);
  }

  onSubmit(event: Event) {
    event.preventDefault();
    this.onDeposit();
  }

  private transactionId: any;

  public onDeposit() {
    this.buttonDisabled = true;
    this.successMessageService.clearMessage();
    this.error = null;

    let depositFormObj: any = this.depositForm.value;
    depositFormObj.amount = parseFloat(this.depositForm.get('amount').value).toFixed(2);
    depositFormObj.bonusCode = this.bonusCode;
    depositFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    depositFormObj.customerAccountID = this.accounts[this.selectedAccount].customerAccountID;

    /**
     * deposit is server-to-server
     * client expects a Notification for approved/failes
     */

    this.showLoadingSecond()

    this.cashierService.callPayWithMyBankDeposit(depositFormObj).subscribe((response: any) => {
      if (response && !!response.result) {
        this.transactionId = response.payload.paymentRequestID;


        clearTimeout(this.depositTimeout);

        this.exceededDepositLimit = false;
        if ('hasExceededDepositLimit' in response.payload) {
          this.exceededDepositLimit = response.payload.hasExceededDepositLimit;
        }

        this.depositTimeout = setTimeout(() => {
          this.loading?.dismiss()
          this.navigator.navigateTo("DepositSuccessFailureComponent", {}, { amount: this.depositForm.get('amount').value, status: false, message: "Unsuccessful, your deposit is still in process, please check again later." });
        }, this.timeoutDepositTimer * 1000);

      } else {
        this.loading?.dismiss();
        this.buttonDisabled = false;
        clearTimeout(this.depositTimeout);
      }
    }, (error) => {
      this.buttonDisabled = false;
      this.loading?.dismiss();
      clearTimeout(this.depositTimeout);
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });

  }

  //Added callBackFn to display deposit status page for DepositThresholdPage scenario
  displayDepositConfirmation = () => {
    this.navigator.navigateTo('DepositSuccessFailureComponent', {}, { status: true });
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

}
